import env from '../core/env'
import { noop } from '../core/lang'
import bridge from '../bridge'

function one (opts, cb = noop) {
  if (env.is('passenger')) {
    bridge.commonPay(opts, cb)
  } else {
    cb({ errno: -1, errmsg: '只有乘客端暂时支持支付' }, {})
  }
}

export default one
